import React, {Component} from 'react';
import {Col, List, Modal, Row} from "antd";
import {getCamelCaseType} from "../WheelsExchangeUtils";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import LabeledText from "../../common/text/LabeledText";
import SAInputNumberLabel from "../../common/input/SAInputNumberLabel";
import {withRouter} from "react-router-dom";

class PlanningSlotEditModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      slot: {},
      errors: {}
    }
  }

  componentDidMount() {
    const slotCopy = {...(this.props.slot || {})};
    this.setState({slot: slotCopy})
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.updateWheelsExchangeSlots && nextProps.updateWheelsExchangeSlots.error) {
      // handle error in this lifecycle to prevent modal to open with previous errors
      this.setState({errors: nextProps.updateWheelsExchangeSlots.error.content || {}});
    }
  }

  onCustomerRemove = index => {
    const {slot} = this.state;
    slot.customers.splice(index, 1);
    this.setState({slot});
  };

  onNumberOfTeamsChange = numberOfTeams => {
    const {slot} = this.state;
    slot.numberOfTeams = numberOfTeams;
    this.setState({slot});
  };

  onModalClose = () => {
    this.props.dispatchShowWheelsExchangeEditModal(false);
  };

  onSave = () => {
    const {slot} = this.state;
    this.props.onUpdate(slot);
  };

  switchAppointment = (index) => {
    const {slot} = this.state;
    const {switchDates} = this.props;
    switchDates(slot.customers[index])
    this.onModalClose();
  }

  render() {
    const {intl: {formatMessage}, history, updateWheelsExchangeSlots: {loading}} = this.props;
    const {slot: {customers = [], numberOfTeams}, errors} = this.state;

    return (
      <Modal
        title={formatMessage({id: 'section.exchange-management.modal.show'})}
        visible={true} // visibility is handled in parent's component to allow demount
        onCancel={this.onModalClose}
        onOk={this.onSave}
        confirmLoading={loading}
        width={800}
      >
        <div>
          <SAInputNumberLabel label={formatMessage({id: "placeholder.teams-size"})} value={numberOfTeams} onChange={this.onNumberOfTeamsChange}
                              min={0} error={errors[`numberOfTeams`]}
          />
        </div>

        <div style={{maxHeight: '40rem', overflow: 'auto'}}>
          <List className="list" dataSource={customers}
                loading={loading}
                renderItem={(item, index) => (
                  <List.Item style={{border: '1px solid #e6e6e6', paddingLeft:'12px'}}>
                    <Row gutter={16} style={{width:'100%'}}>
                      <Col span={8}>
                        <LabeledText label="customer.firstname" text={item.firstName} />
                        <LabeledText label="customer.lastname" text={item.lastName} />
                        <LabeledText label="summary.phone" text={item.phoneNumber} />
                      </Col>
                      <Col span={8}>
                        <LabeledText label="vehicle.make" text={item.brand} />
                        <LabeledText label="vehicle.model" text={item.model} />
                        <LabeledText label="vehicle.plate" text={item.plate} />
                      </Col>
                      <Col span={8}>
                        {item.interventionId ?
                          <div style={{display: 'flex', flexDirection: 'column', gap: 8}}>
                            <button
                              className="btn btn-sm btn-primary"
                              type="primary"
                              onClick={() => history.push(`/interventions/${item.interventionId}`)}
                            >
                              {formatMessage({id: 'summary.appointment.history'})}
                            </button>
                            <button
                              className="btn btn-sm btn-primary"
                              type="primary"
                              onClick={() => this.switchAppointment(index)}
                            >
                              {`${formatMessage({id: 'action.switch'})}: ${formatMessage({id: 'appointment.detail.services.tires-exchange.type.WHEELS'})} `
                                + `<-> ${formatMessage({id: 'appointment.detail.services.tires-exchange.type.TIRES'})}`}
                            </button>
                          </div>
                          :
                          <button className="btn btn-sm btn-primary" type="primary" onClick={() => this.onCustomerRemove(index)}>
                            <FormattedMessage id="action.delete" />
                          </button>
                        }
                      </Col>
                    </Row>
                  </List.Item>
                )}
          />
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const camelCaseType = getCamelCaseType(ownProps.type);
  const updateWheelsExchangeSlots = state[`update${camelCaseType}ExchangeCustomers`];
  return {updateWheelsExchangeSlots}
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatchShowWheelsExchangeEditModal: show => dispatch({type: `SHOW_${ownProps.type}_EXCHANGE_SLOT_EDIT_MODAL`, show}),
  dispatchShowWheelsExchangeSwitchModal: show => dispatch({type: `SHOW_${ownProps.type}_EXCHANGE_SLOT_SWITCH_MODAL`, show}),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(injectIntl(PlanningSlotEditModal))
);



// WEBPACK FOOTER //
// ./src/components/wheelsexchange/management/PlanningSlotEditModal.js